function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.12 11.78C11.05 11.77 10.96 11.77 10.88 11.78C9.11997 11.72 7.71997 10.28 7.71997 8.50998C7.71997 6.69998 9.17997 5.22998 11 5.22998C12.81 5.22998 14.28 6.69998 14.28 8.50998C14.27 10.28 12.88 11.72 11.12 11.78Z",
    stroke: "#FCC226",
    style: {
      stroke: "#FCC226",
      stroke: "color(display-p3 0.9882 0.7608 0.1490)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.74 18.3801C15.96 20.0101 13.6 21.0001 11 21.0001C8.40001 21.0001 6.04001 20.0101 4.26001 18.3801C4.36001 17.4401 4.96001 16.5201 6.03001 15.8001C8.77001 13.9801 13.25 13.9801 15.97 15.8001C17.04 16.5201 17.64 17.4401 17.74 18.3801Z",
    stroke: "#FCC226",
    style: {
      stroke: "#FCC226",
      stroke: "color(display-p3 0.9882 0.7608 0.1490)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z",
    stroke: "#FCC226",
    style: {
      stroke: "#FCC226",
      stroke: "color(display-p3 0.9882 0.7608 0.1490)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser2);
export default __webpack_public_path__ + "static/media/user2.26b003850eee502956b5ae39d8514d16.svg";
export { ForwardRef as ReactComponent };